export default __webpack_public_path__ + "static/media/gallery-spectrespecs_00.676855ea.jpg";